
import { useState } from "react";
import { Box, Tab, Tabs, } from "@mui/material";
import { a11yProps, EstadoSolicitudAplicaGremios, sizeTab, } from "@/shared";
import { CustomTabPanel, SingleTableBoxScene } from "@/shared/components/ui";
import TableSolicitudGremios from "../shared/componente/TableSolicitudGremios";

export default function SolicitudVentaGremiosPage() {


  const [valueTab, setValueTab] = useState(0);
  return (
    <SingleTableBoxScene title={"Solicitud Promoción Gremios"}
      py={2}
    >
      <Box sx={{ bgcolor: 'background.paper', maxWidth: sizeTab, paddingBottom: 2 }} >
        <Tabs
          value={valueTab}
          onChange={(_event: React.SyntheticEvent, newValue: number) => {
            setValueTab(newValue);
          }}
          variant="scrollable"
          scrollButtons="auto"
          allowScrollButtonsMobile
          aria-label="scrollable force tabs preventa"
        >
          <Tab label={'Pendiente'} {...a11yProps(0)} />
          <Tab label={'Aprobado'} {...a11yProps(0)} />
          <Tab label={'Negado'} {...a11yProps(0)} />
        </Tabs>
      </Box>
      <CustomTabPanel value={valueTab} index={0}>
        <TableSolicitudGremios />
      </CustomTabPanel>
      <CustomTabPanel value={valueTab} index={1}>
        <TableSolicitudGremios
          enableActions={false}
          estado_solicitud={EstadoSolicitudAplicaGremios.APROBADO}
        />
      </CustomTabPanel>
      <CustomTabPanel value={valueTab} index={2}>
        <TableSolicitudGremios
          enableActions={false}
          estado_solicitud={EstadoSolicitudAplicaGremios.RECHAZADO}
        />
      </CustomTabPanel>

    </SingleTableBoxScene >
  );
}